import { z } from 'zod';
import { RegionSchema } from "../../../services/region/response/RegionResponse";
import { GroupSchema } from "../../../services/group/response/IndexGroupResponse";


const DataSchema = z.object({
    id: z.string().uuid(),
    // Nullable: a deactivated property has its Channex mapping deleted,
    // which nulls channex_id server-side (DeactivatePropertyChannexJob) —
    // see the identical comment in services/properties/response/PropertyBaseSchema.ts.
    channex_id: z.string().uuid().nullable(),
    name: z.string(),
    accommodation_type: z.number(),
    preferred_currency: z.string(),
    time_zone: z.string(),
    primary_email: z.string().email("Invalid email format"),
    cc_emails: z.array(z.string().email("Invalid email format")).nullable().optional(),
    accounting_email: z.union([z.string().email("Invalid email format"), z.null()]).optional(),
    mobile_number_country_code: z.nullable(z.string()).optional(),
    mobile_number: z.nullable(z.string()).optional(),
    enable_cvv: z.number().min(0).max(1), // 0 or 1
    primary_phone_country_code: z.nullable(z.string()).optional(),
    primary_phone: z.nullable(z.string()).optional(),
    website: z.nullable(z.string().url("Invalid URL format")).optional(),
    email_autofill: z.preprocess(
        (val) => (val === "" ? null : val), // Convert empty string to null
        z.union([z.string().email("Invalid email format"), z.null()]).optional()
    ).optional(),
    country: z.nullable(z.string()).optional(),
    state: z.nullable(z.string()).optional(),
    city: z.nullable(z.string()).optional(),
    street_address: z.nullable(z.string()).optional(),
    postal_code: z.nullable(z.string()).optional(),
    prefix_booking_number: z.string().nullable().optional(),
    hotel_tax_number: z.string().nullable().optional(),
    latitude: z.string().nullable().optional(),
    longitude: z.string().nullable().optional(),
    description: z.string().nullable().optional(),
    term_condition: z.string().nullable().optional(),
    cancellation_policy: z.string().nullable().optional(),
    facebook_link: z.string().nullable().optional(),
    instagram_link: z.string().nullable().optional(),
    youtube_link: z.string().nullable().optional(),
    tiktok_link: z.string().nullable().optional(),
    logo: z.string().nullable().optional(),
    cover_image: z.string().nullable().optional(),
    created_at: z.string(),
    updated_at: z.string(),
    is_full_sync: z.boolean(),
    property_type: z.string(),
    logo_url: z.string().nullable().optional(),
    checkin_time: z.string().nullable().optional(),
    checkout_time: z.string().nullable().optional(),
    users: z.array(z.unknown()).optional(),
    region_id: z.string().uuid().nullable().optional(),
    region: z.lazy(() => RegionSchema).nullable().optional(),
    // 1 property seharusnya cuma punya 1 group (whitelabel) — array-nya tetap
    // dipertahankan (bukan single object) supaya UI bisa mendeteksi & menampilkan
    // alert kalau ada property dengan 0 atau >1 group (data lama/inkonsisten).
    groups: z.array(GroupSchema).optional(),
});

export const PropertyResponseSchema = z.object({
    success: z.boolean(),
    message: z.string(),
    code: z.number(),
    data: DataSchema,
});

export type PropertyResponseType = z.infer<typeof PropertyResponseSchema>;
